<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8">
        <div class="d-flex justify-space-between blog-label">
          <h2 class="font-weight-light pl-2">{{ title }}</h2>
          <BlogPaginationFilter :count="total" :page="page" :size="pageSize" />
        </div>
        <h3 v-if="loading" class="d-flex justify-center mt-6">
          <v-progress-circular
            :size="60"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </h3>
        <v-row v-else no-gutters>
          <v-col v-for="blog in blogs" :key="blog.slug" class="pa-2" sm="4">
            <BlogPostPreview :post="blog" />
          </v-col>
          <v-col
            v-if="total === 0 && !loading"
            cols="8"
            offset="2"
            class="mt-8"
          >
            <v-alert type="info" color="secondary" border="left" text>
              Currently, there are no blogs. Try with another or maybe you can
              suggest an adventure to share with the happyly community.
            </v-alert>
          </v-col>
        </v-row>
        <div
          v-if="!loading && total > pageSize"
          class="d-flex justify-space-between blog-label"
        >
          <h2 class="font-weight-light pl-2">{{ title }}</h2>
          <BlogPaginationFilter :count="total" :page="page" :size="pageSize" />
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="blogSidebar">
          <BlogSearchTermFilter />
          <h4 class="font-weight-light">Filter by city</h4>
          <BlogLocationFilter />
          <NewsletterSignupCTA />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import BlogSearchTermFilter from '@/components/blog/SearchTermFilter'
import BlogLocationFilter from '@/components/blog/LocationFilter'
import BlogPaginationFilter from '@/components/blog/BlogPaginationFilter'
import BlogPostPreview from '@/components/blog/BlogPostPreview'
import NewsletterSignupCTA from '@/components/NewsletterSignupCTA'

export default {
  name: 'BlogIndexPage',
  components: {
    BlogSearchTermFilter,
    BlogLocationFilter,
    BlogPaginationFilter,
    BlogPostPreview,
    NewsletterSignupCTA,
  },
  data: () => ({
    page: 1,
    pageSize: 10,
  }),
  computed: {
    ...mapState('blogs', ['blogs', 'total', 'loading', 'error']),
    ...mapState('location', ['cityLocation', 'navigatorPosition']),
    ...mapState('route', ['query']),
    title() {
      const city = this.cityLocation

      if (city) return `Showing blog posts for ${city.name}`

      return 'All Blogs'
    },
  },
  watch: {
    $route(to, from) {
      const queryTo = to.query
      const queryFrom = from.query
      if (
        queryFrom.page !== queryTo.page ||
        queryFrom.city !== queryTo.city ||
        queryFrom.searchTerm !== queryTo.searchTerm
      )
        this.retrieveBlogs()
      if (this.query.page > 0) this.page = Number(this.query.page)
    },
  },
  mounted() {
    this.retrieveBlogs()

    this.$fb.track('PageView', { page: 'Blogs' })
  },
  methods: {
    retrieveBlogs() {
      const city =
        this.query.city === 'nearby'
          ? this.query.city
          : Number(this.query.city) || null

      const params = {
        city,
        searchTerm: this.query.searchTerm,
        page: Number(this.query.page || 1),
        pageSize: this.pageSize,
        ...(this.navigatorPosition !== null && city === 'nearby'
          ? {
              geolocationPosition: {
                latitude: this.navigatorPosition.latitude,
                longitude: this.navigatorPosition.longitude,
              },
            }
          : {}),
      }

      this.$store.dispatch('blogs/BLOGS/REQUEST', params)
    },
  },
  scrollToTop: true,
}
</script>

<style>
.blogSidebar {
  position: sticky;
  top: 96px;
}
</style>
